/**
 * dia-variant-image.js
 *
 * On a color/variant change, move that variant's image to the FIRST position of
 * the product gallery so the leading image always reflects the selected color.
 * The rest of the gallery keeps its relative order.
 *
 * Why this exists: on the desktop "grid" layout the gallery is a CSS multi-column
 * list (`columns: 2`), which renders slides in DOM order and ignores the CSS
 * `order` property. The theme's native variant handling only toggles a
 * `media--active` class (used by the single/fader layouts), which has no visual
 * effect in the grid. Reordering the DOM node is the reliable way to surface the
 * color's photo first there.
 *
 * Scope: only the grid layouts (no desktop thumbnails/fader), where there is no
 * dedicated "main" image that the theme already swaps.
 */
(function () {
  'use strict';

  var MEDIA_LIST_SELECTOR = '[data-product-media-list]';

  function moveMediaToFront(productInfo, mediaId) {
    if (!mediaId) return;

    var mediaList = productInfo.querySelector(MEDIA_LIST_SELECTOR);
    if (!mediaList) return;

    // Grid layouts only: skip when the desktop gallery is a fader/thumbnail view,
    // which already presents a single swapping main image.
    var productImages = productInfo.querySelector('product-images');
    if (productImages && productImages.hasAttribute('data-fader-desktop')) return;

    var slide = mediaList.querySelector('[data-image-id="' + mediaId + '"]');
    if (!slide || slide === mediaList.firstElementChild) return;

    mediaList.insertBefore(slide, mediaList.firstElementChild);
  }

  function init() {
    // The theme exposes a pub/sub bus; bail quietly if it is unavailable.
    if (typeof window.subscribe !== 'function' || !window.theme || !window.theme.PUB_SUB_EVENTS) {
      return;
    }

    window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function (payload) {
      // Never let a DOM hiccup here break the theme's other variantChange
      // subscribers (price, inventory, etc.).
      try {
        var data = payload && payload.data;
        if (!data || !data.variant) return;

        var productInfo = document.querySelector(
          'product-info[data-section="' + data.sectionId + '"]'
        ) || document.querySelector('product-info');
        if (!productInfo) return;

        var featuredMedia = data.variant.featured_media;
        if (featuredMedia && featuredMedia.id) {
          moveMediaToFront(productInfo, featuredMedia.id);
        }
      } catch (err) {
        console.warn('dia-variant-image: reorder skipped', err);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
